import { useMemo, useState } from 'react';
import * as R from 'ramda';

import { Icon, IconButton } from '@atom/mui';
import colors from '@atom/styles/colors';
import { DataType } from '@atom/types/dataType';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import AttributeFilter from './AttributeFilter';

import classes from './attributeFilterGroup.module.css';

interface Props {
  assetFiltersCart: any;
  onAssetFiltersChange: (
    attributeId: string,
    value: any,
    dataType: DataType,
  ) => void;
  attributeGroup: any;
}

const AttributeFilterGroup = ({
  assetFiltersCart,
  onAssetFiltersChange,
  attributeGroup,
}: Props) => {
  const [expanded, setExpanded] = useState<boolean>(true);

  const icon = expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
  const filteredAttributes = attributeGroup?.attributes.filter(
    attribute => attribute?.isFilterable,
  );

  const hasValues = useMemo(() => {
    const attributeIds = attributeGroup?.attributes.map(
      attribute => attribute?.id,
    );
    const attributeFilterIds = R.keys(assetFiltersCart).reduce(
      (acc, attributeId) => {
        return isNilOrEmpty(assetFiltersCart[attributeId])
          ? acc
          : [...acc, attributeId];
      },
      [],
    );

    return R.intersection(attributeIds, attributeFilterIds).length > 0;
  }, [attributeGroup, assetFiltersCart]);

  return (
    <div className={classes.inventoryFilterGroupContainer}>
      <div className={classes.inventoryFilterGroupHeader}>
        <div
          className={classes.inventoryFilterGroupName}
          style={{
            color: hasValues ? colors.brand.blue : colors.neutral.dark,
          }}
        >
          {attributeGroup.name}
        </div>
        <div>
          <IconButton onClick={() => setExpanded(!expanded)}>
            <Icon color={colors.neutral.gray}>{icon}</Icon>
          </IconButton>
        </div>
      </div>
      {expanded &&
        filteredAttributes.map((attribute, index) => (
          <AttributeFilter
            key={attribute?.id + index}
            attribute={attribute}
            onAssetFiltersChange={onAssetFiltersChange}
            assetFiltersCart={assetFiltersCart}
          />
        ))}
    </div>
  );
};

export default AttributeFilterGroup;
